<template>
  <div data-testid="forward-sales-intro">
    <p class="forward-sales-intro__body mb-3">
      {{ $t("forwards.pools.intro.body") }}
    </p>
    <ForwardSalesMaterialsComponent :country />
  </div>
</template>

<script setup lang="ts">
import ForwardSalesMaterialsComponent from "@/forwards2/components/ForwardSalesMaterialsComponent.vue";

/**
 * The introduction to forward sales, then the forward sales materials it leads into. One text for
 * everyone who creates pools: the dashboard's call to create a first pool and the forward sales
 * guide show it under their own titles. It also says what the materials' own description would
 * (`production_strategy.forward_materials.description`, the small-producer panel's), so it stands in
 * for it. `country` picks the materials' language versions (`ForwardSalesMaterialsComponent`).
 */
withDefaults(
  defineProps<{
    country?: string | null;
  }>(),
  { country: null }
);
</script>

<style scoped lang="scss">
// A readable line length inside a full-width card.
.forward-sales-intro__body {
  max-width: 48rem;
}
</style>
